export default (state = {}, {}) => {
  return {
    ...state,
    myTeams: {},
  };
};
